import ApiClient from '@package/services/src/ApiClient';
import Result from '@package/services/src/Result';

import { ContentResponse } from '../content/types';

import { AlertsService } from './services';

export default class AlertsApiService implements AlertsService {
  // eslint-disable-next-line prettier/prettier
  public constructor(private readonly apiClient: ApiClient) {}

  public async getSubscribeAlert(): Promise<Result<string>> {
    const res = await this.apiClient.get('/content/promotion-alerts/alert-footer');

    const json: ContentResponse<string> = await res.json();

    return new Result(json.content);
  }

  public async getCheckoutAlert(): Promise<Result<string | undefined>> {
    try {
      const res = await this.apiClient.get('/shoppingCart/alertMessage');
      const text = await res.text();
      return new Result(text);
    } catch (error) {
      return new Result(undefined);
    }
  }

  public async getMailingListAlert(): Promise<Result<string | undefined>> {
    try {
      const res = await this.apiClient.get('/content/promotion-alerts/alert-mailing-list');

      const json: ContentResponse<string> = await res.json();
      return new Result(json.content);
    } catch (error) {
      return new Result(undefined);
    }
  }

  public async getCookiesTermsAlert(): Promise<Result<string | undefined>> {
    try {
      const res = await this.apiClient.get('/content/promotion-alerts/alert-cookies');

      const json: ContentResponse<string> = await res.json();

      return new Result(json.content);
    } catch (error) {
      console.error('cant get cookies terms message', error);
      return new Result(undefined);
    }
  }

  public async getBullseyeBucksAlert(): Promise<Result<string | undefined>> {
    try {
      const res = await this.apiClient.get('/content/promotion-alerts/alert-bb-popup');

      const json: ContentResponse<string> = await res.json();
      return new Result(json.content);
    } catch (error) {
      console.error('cant get Bullseye Bucks message', error);
      return new Result(undefined);
    }
  }

  public async getTermsAlert(): Promise<Result<string | null>> {
    try {
      const res = await this.apiClient.get('/content/promotion-alerts/alert-coupon-terms');

      const json: ContentResponse<string> = await res.json();
      return new Result(json.content);
    } catch (error) {
      console.error('cant get promotion terms message', error);
      return new Result(null);
    }
  }

  public async getImportantNoticeAlert(): Promise<Result<string | null>> {
    try {
      const res = await this.apiClient.get('/content/promotion-alerts/alert-shipping-processing-time');

      const json: ContentResponse<string> = await res.json();
      return new Result(json.content);
    } catch (error) {
      console.error('cant get promotion terms message', error);
      return new Result(null);
    }
  }

  public async getPaymentsWarning(): Promise<Result<string | null>> {
    try {
      const res = await this.apiClient.get('/content/promotion-alerts/alert-credit-card');

      const json: ContentResponse<string> = await res.json();
      return new Result(json.content);
    } catch (error) {
      console.error('cant get payments warning message', error);
      return new Result(null);
    }
  }
}
